import React, { useState, useEffect } from 'react';
import {
  CheckboxContainer,
  OptionItem,
  HiddenCheckbox,
  StyledCheckbox,
  Label,
  Checkmark,
  CardImage,
  OptionLabel,
  LeftColumn,
  RightColumn,
  OptionsContainer,
  Row
} from './styles';

export const sdgToCardValueMap = {
  no_poverty: "erradicacao-pobreza",
  zero_hunger: "fome-zero",
  good_health: "saude-bem-estar",
  quality_education: "educacao-qualidade",
  gender_equality: "igualdade-genero",
  clean_water: "agua-potavel-saneamento",
  affordable_energy: "energia-limpa",
  decent_work: "trabalho-decente",
  industry_innovation: "industria-inovacao",
  reduced_inequalities: "reducao-desigualdade",
  sustainable_cities: "cidades-comunidades",
  responsible_consumption: "consumo-producao",
  climate_action: "mudanca-do-clima",
  life_below_water: "vida-na-agua",
  life_on_land: "vida-terrestre",
  peace_justice: "paz-justica",
  partnerships: "parcerias",
};

export const cardOptions = [
  { value: "erradicacao-pobreza", label: "Erradicação da Pobreza" },
  { value: "fome-zero", label: "Fome Zero e Agricultura Sustentável" },
  { value: "saude-bem-estar", label: "Saúde e Bem-Estar" },
  { value: "educacao-qualidade", label: "Educação de Qualidade" },
  { value: "igualdade-genero", label: "Igualdade de Gênero" },
  { value: "agua-potavel-saneamento", label: "Água Potável e Saneamento" },
  { value: "energia-limpa", label: "Energia Limpa e acessível" },
  { value: "trabalho-decente", label: "Trabalho Decente e Crescimento Econômico" },
  { value: "industria-inovacao", label: "Indústria, Inovação e Infraestrutura" },
  { value: "reducao-desigualdade", label: "Redução das Desigualdades" },
  { value: "cidades-comunidades", label: "Cidades e Comunidades Sustentáveis" },
  { value: "consumo-producao", label: "Consumo e Produção Responsáveis" },
  { value: "mudanca-do-clima", label: "Ação Contra a Mudança Global do Clima" },
  { value: "vida-na-agua", label: "Vida na Água" },
  { value: "vida-terrestre", label: "Vida Terrestre" },
  { value: "paz-justica", label: "Paz, Justiça e Instituições Eficazes" },
  { value: "parcerias", label: "Parcerias e Meios de Implementação" }
];

export const CardCheckbox = ({ onSelectionChange, initialSelection = [] }) => {
  const [selectedCards, setSelectedCards] = useState(initialSelection);

  // Atualiza apenas quando initialSelection realmente muda (comparação profunda)
  useEffect(() => {
    const isEqual = 
      selectedCards.length === initialSelection.length &&
      selectedCards.every(item => initialSelection.includes(item)) &&
      initialSelection.every(item => selectedCards.includes(item));

    if (!isEqual) {
      setSelectedCards(initialSelection);
    }
  }, [initialSelection]); // Removido selectedCards da dependência

  const handleCheckboxChange = (cardValue) => {
    const newSelection = selectedCards.includes(cardValue)
      ? selectedCards.filter(v => v !== cardValue)
      : [...selectedCards, cardValue];

    setSelectedCards(newSelection);
    
    if (onSelectionChange) {
      onSelectionChange(newSelection);
    }
  };

  const halfLength = Math.ceil(cardOptions.length / 2);
  const leftOptions = cardOptions.slice(0, halfLength);
  const rightOptions = cardOptions.slice(halfLength);

  return (
    <CheckboxContainer>
      <Row>
        <Label>Selecione os cards para o projeto:</Label>
        <OptionsContainer>
          <LeftColumn>
            {leftOptions.map((card) => (
              <OptionItem key={card.value}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <HiddenCheckbox
                    type="checkbox"
                    id={`card-${card.value}`}
                    checked={selectedCards.includes(card.value)}
                    onChange={() => handleCheckboxChange(card.value)}
                  />
                  <StyledCheckbox checked={selectedCards.includes(card.value)}>
                    <Checkmark
                      viewBox="0 0 24 24"
                      checked={selectedCards.includes(card.value)}
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </Checkmark>
                  </StyledCheckbox>
                  {card.image && <CardImage src={card.image} alt={card.label} />}
                  <OptionLabel>{card.label}</OptionLabel>
                </label>
              </OptionItem>
            ))}
          </LeftColumn>
          <RightColumn>
            {rightOptions.map((card) => (
              <OptionItem key={card.value}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <HiddenCheckbox
                    type="checkbox"
                    id={`card-${card.value}`}
                    checked={selectedCards.includes(card.value)}
                    onChange={() => handleCheckboxChange(card.value)}
                  />
                  <StyledCheckbox checked={selectedCards.includes(card.value)}>
                    <Checkmark
                      viewBox="0 0 24 24"
                      checked={selectedCards.includes(card.value)}
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </Checkmark>
                  </StyledCheckbox>
                  {card.image && <CardImage src={card.image} alt={card.label} />}
                  <OptionLabel>{card.label}</OptionLabel>
                </label>
              </OptionItem>
            ))}
          </RightColumn>
        </OptionsContainer>
      </Row>
    </CheckboxContainer>
  );
};